export default __webpack_public_path__ + "assets/15112a.svg";